// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__gu6zA","approved":"Status_approved__1nnAi","rejected":"Status_rejected__1uKxy","expired":"Status_expired__3_5sq","label":"Status_label__3kfTD"};